
import {rzNotification} from 'razlet-ui';

export default {
  name: 'sulu-untranslated',
  components: {
    rzNotification,
  },
  props: {
    locale: {
      type: String,
      required: true,
    },
  },
  computed: {
    fromLang() {
      return this.$t(`sulu.languages.default.${this.$locale}`);
    },
    toLang() {
      return this.$t(`sulu.languages.on.${this.locale}`);
    },
  },
};
